<template lang="pug">
  div.home
    v-overlay(
      :value="$store.state.showModaAgendamentolSucesso"
    )
      v-card.pa-2.ml-2.mr-3(
        light
        min-width="320"
        max-width="375"
        min-height="288"
      )
        v-card-title.title
          h5.float-left {{ $t('agendamento-realizado') }}
          v-icon(
            size="35"
            color="black"
            style="cursor: pointer; right: 15px; position: absolute;"
            @click="$store.state.showModaAgendamentolSucesso = !$store.state.showModaAgendamentolSucesso"
          ) close

        v-card-text.font-weight-regular.text--primary.subtitle-1.pr-4
          p {{ $t('agendamento-realizado-sucesso') }}
          p
            strong {{ $t('protocolo') }}: 
            span {{ $store.state.protocolo }}
            br
            strong {{ $t('servico') }}: 
            span {{ $store.state.servico }}
            br
            strong {{ $t('polo') }}: 
            span {{ $store.state.polo }}
            br
            strong {{ $t('endereco') }}: 
            span {{ $store.state.endereco }}
            br
            strong {{ $t('horario') }}: 
            span {{ $store.state.horario }}

          span.d-none.d-md-flex(
            v-if="play_store_link"
          )
            p(
              v-html="$t('msg-baixe-aplicativo')"
              )

        v-card-actions.pa-0.ml-n2.mr-3.d-none.d-md-flex(
          v-if="play_store_link"
        )
          div.row
            div.col-6
              v-img(
                contain
                position="left center"
                height="28"
                width="107"
                src="@/assets/images/googleplay.png"
                lazy-src="@/assets/images/googleplay-small.png"
                style="margin-left: 25px;"
              )
            div.col-6.text-right
              v-btn.text-none(
                dark
                color="#C4170C"
                :href="play_store_link"
                target="__blank"
                small
                @click="$store.state.showModaAgendamentolSucesso = !$store.state.showModaAgendamentolSucesso"
              ) {{ $t('ir-para-playstore') }}

    div.banner 
      style="position: relative" 
      v-img.hidden-xs-only(
        style: "position: absolute"
        max-width="100%"
        src="@/assets/images/banner-iptu-2022.jpg"
      )

      v-img.hidden-sm-and-up(
        max-width="100%"
        src="@/assets/images/banner-iptu-sm-2022.jpg"
      )

      div.row(style="background:#333333; justify-content: center;")
        <span class="consulta-sem-agendamento">Para consulta de IPTU sem agendamento, <a href='https://sim.marica.rj.gov.br/iptu' target="_blank">clique aqui</a></span>

    div.row.agende-servico
      div.col-xs-12.col-md-12
          div.row(style="justify-content: center;" v-if="isResponsive()")
              v-img.hidden-xs-only(
                contain
                min-height="50"
                max-height="284"
                min-width="350"
                max-width="100%"
                src="@/assets/images/banner-servicos.jpg"
              )
              v-img.hidden-sm-and-up(
                  contain
                  max-width="300"
                  max-height="774"
                  src="@/assets/images/banner-servicos-responsivo.jpg"
              )
          div.row(v-else)
              v-img(
                  contain
                  position="center"
                  src="@/assets/images/banner-servicos-responsivo.jpg"
              )
      div#icone.col-xs-12.col-md-4
        v-icon(
          size="120"
          color="black"
        ) people
      div.col-xs-12.col-md-8
        div.row
          div#div-texto-agende.col-xs-12.col-md-12
            p {{ $t('agende-um-servico-link-abaixo') }}
          div#link-agendar-servico.col-xs-12.col-md-3
            v-btn(
              dark
              color="#C4170C"
              to="agendar-servico"
              large
            ) {{ $t('agendar-servico') }}
          div#link-agendar-servico.col-xs-12.col-md-3
            v-btn(
              dark
              outlined
              color="#C4170C"
              to="consultar-agendamento"
              large
            ) {{ $t('Consultar/Cancelar Agendamento') }}
          div.col-md-6.d-none.d-md-flex(
            v-if="play_store_link"
          )
            a(
              :href="play_store_link"
              target="__blank"
            )
              v-img(
                contain
                position="left center"
                height="45"
                width="150"
                src="@/assets/images/googleplay.png"
                lazy-src="@/assets/images/googleplay-small.png"
                style="margin-left: 25px;"
              )

    ServicosOnline

    a(
      :href="link_banner"
    )
      v-img(
        contain
        min-height="50"
        max-height="284"
        min-width="350"
        max-width="100%"
        src="@/assets/images/90203794_2785094974906724_7744599480988598272_n.png"
        lazy-src="@/assets/images/90203794_2785094974906724_7744599480988598272_n-small.png"
        style="margin: 30px 25px 60px 25px;"
      )
</template>

<script lnag="ts">
import { Vue, Component } from "vue-property-decorator";
import ServicosOnline from "@/components/ServicosOnline.vue";

@Component({
  components: {
    ServicosOnline
  },
  data: () => ({
    play_store_link: process.env.VUE_APP_APP_URL,
    link_banner: 'tel:+5521994722294'
  }),
    methods: {
      isResponsive() {
          if(/Android|webOS|iPhone|BlackBerry|IEMobile|Opera Mini/i.test(navigator.userAgent)) {
              console.log(navigator);
              return false;
          } else {
              return true;
          }
      }
    }
})
export default class Home extends Vue {
  beforeCreate() {
    this.$store.state.title = this.$root.title;
  }
}
</script>

<style lang="css">
.banner{
  width: 100%;
}

.consulta-sem-agendamento {
  padding: 20px;
  color: white;
  height: 100%;
  width: auto;
  font: Roboto;
  font-size: 24px;
}

.agende-servico {
  padding: 25px;
  background: #f3f3f3 0% 0% no-repeat padding-box;
}
.agende-servico p {
  font-size: 22px;
}
.agende-servico #div-texto-agende {
  padding-bottom: 0;
  margin-bottom: 0 !important;
}
.agende-servico .v-btn__content {
  text-transform: none;
  font-weight: 400;
}
.agende-servico #icone,
#link-agendar-servico {
  text-align: center !important;
}
@media only screen and (min-width: 960px) {
  .agende-servico #icone,
  #link-agendar-servico {
    text-align: right !important;
  }
  .agende-servico p {
    font-size: 22px;
    padding-bottom: 0;
    margin-bottom: 0 !important;
  }
  .agende-servico #div-texto-agende {
    padding-bottom: 0;
    margin-bottom: 0 !important;
  }
}
</style>
